/*eslint-disable*/
import moment from 'moment';

export default {
    filters: {
        humanizeDate(date, format = 'DD MMM') {
            date = moment(date);
            let now = moment(new Date());
            let dayDiff = date.diff(now, 'day');
            if (dayDiff === 0) {
                return date.format('LT');
            }
            if (dayDiff === -1) {
                return date.calendar();
            }
            if (date.diff(now, 'year')) {
                return date.format('ll');
            }
            return date.format(format);
        }
    }
}